import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";

export const useGetRecipeById = (recipeId: string): UseQueryResult<IRecipe> => {
    const auth = useAuth();

    return useQuery<IRecipe>(
        ["recipe", recipeId],
        async () => {
            if (!auth.token) {
                throw new Error(
                    `Cannot fetch recipe ${recipeId} without authorization token.`,
                );
            }

            return await recipes.Recipe.getById({
                id: recipeId,
                token: auth.token,
            });
        },
        { enabled: recipeId !== "new" && recipeId !== "" },
    );
};
